/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ListIcon
 */
export default class ListIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M8 7h13c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1zm13 4H8c-.6 0-1 .4-1 1s.4 1 1 1h13c.6 0 1-.4 1-1s-.4-1-1-1zm0 6H8c-.6 0-1 .4-1 1s.4 1 1 1h13c.6 0 1-.4 1-1s-.4-1-1-1zM3.005 19.13a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zm0-6a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zm0-6a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

